exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login_form[data-v-130a1424]{cursor:auto;padding-top:2rem!important;padding-bottom:2rem!important}#facebook_login img[data-v-130a1424]{text-align:center;max-width:100%;width:220px;margin-top:16px}@media (max-width:575px){#login_form[data-v-130a1424]{padding-top:1.2rem!important;padding-bottom:1.2rem!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-130a1424","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ForgotPassword.vue
// module id = 157
// module chunks = 0